module.exports = __webpack_public_path__ + "static/media/sidebar_open.5e7fe037.svg";